import React from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Text } from 'elements';
import { CWindowWidth } from 'constants/base.const';
import { Button } from 'antd';
import { Colors, SecondaryColor } from 'GlobalStyles';
import KakaoIcon from 'assets/icons/kakaopay.svg';

const Complete = () => {
  const history = useHistory();

  return (
    <Grid justify='center' margin='0 0 150px 0' md={{ margin: '0 0 50px 0' }}>
      <Grid
        maxWidth={`${CWindowWidth}px`}
        padding='50px'
        md={{ padding: '50px 20px' }}
        sm={{ padding: '16px' }}
      >
        <Grid padding='0 7%' md={{ padding: '0 3%' }} sm={{ padding: '0' }}>
          <Grid>
            <Text bold size='2.8rem' sm={{ size: '2rem' }}>
              결제가 완료되었습니다.
            </Text>
          </Grid>

          <Grid marginTop='40px' sm={{ marginTop: '20px' }}>
            <Text bold size='1.2rem'>
              결제 정보
            </Text>
          </Grid>

          <Grid marginTop='13px' sm={{ marginTop: '8px' }}>
            <Grid isNoWrap backgroundColor={Colors.grey0} padding='16px' gap='18px' maxWidth='400px'>
              <Grid maxWidth='380px' width='100%'>
                <Grid
                  padding='8px 0'
                  justify='space-between'
                  gap='8px'
                  isNoWrap
                  style={{ borderBottom: `1px solid ${Colors.grey1}` }}
                >
                  <Grid isInline width='70px'>
                    <Text>상품명</Text>
                  </Grid>
                  <Grid isInline minWidth='150px' justify='flex-end'>
                    <Text>CS Case 2021 시즌 - Case #1</Text>
                  </Grid>
                </Grid>
                <Grid
                  padding='8px 0'
                  justify='space-between'
                  gap='8px'
                  isNoWrap
                  style={{ borderBottom: `1px solid ${Colors.grey1}` }}
                >
                  <Grid isInline width='70px'>
                    <Text>필요 크레딧</Text>
                  </Grid>
                  <Grid isInline minWidth='150px' justify='flex-end'>
                    <Text>30 CS</Text>
                  </Grid>
                </Grid>
                <Grid
                  padding='8px 0'
                  justify='space-between'
                  gap='8px'
                  isNoWrap
                  style={{ borderBottom: `1px solid ${Colors.grey1}` }}
                >
                  <Grid isInline width='70px'>
                    <Text color={Colors.danger}>사용 크레딧</Text>
                  </Grid>
                  <Grid isInline minWidth='150px' justify='flex-end'>
                    <Text color={Colors.danger}>0 CS</Text>
                  </Grid>
                </Grid>
                <Grid
                  padding='8px 0'
                  justify='space-between'
                  gap='8px'
                  isNoWrap
                  style={{ borderBottom: `1px solid ${Colors.grey1}` }}
                >
                  <Grid isInline width='70px'>
                    <Text>구매 크레딧</Text>
                  </Grid>
                  <Grid isInline minWidth='150px' justify='flex-end'>
                    <Text>30 CS</Text>
                  </Grid>
                </Grid>
                <Grid
                  padding='8px 0'
                  justify='space-between'
                  gap='8px'
                  isNoWrap
                  style={{ borderBottom: `1px solid ${Colors.grey1}` }}
                >
                  <Grid isInline width='70px'>
                    <Text color={SecondaryColor}>구매 크레딧</Text>
                  </Grid>
                  <Grid isInline minWidth='150px' justify='flex-end'>
                    <Text color={SecondaryColor}>30 CS</Text>
                  </Grid>
                </Grid>
                <Grid
                  padding='8px 0'
                  justify='space-between'
                  gap='8px'
                  isNoWrap
                  style={{ borderBottom: `1px solid ${Colors.grey1}` }}
                >
                  <Grid isInline width='70px'>
                    <Text>결제 수단</Text>
                  </Grid>
                  <Grid isInline minWidth='150px' justify='flex-end'>
                    <Grid
                      isInline
                      image={KakaoIcon}
                      imageSize='contain'
                      imagePosition='center left'
                      width='50px'
                      height='20px'
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid marginTop='30px' width='400px' sm={{ marginTop: '15px' }}>
            <Button
              type='primary'
              className='large'
              style={{ width: '100%' }}
              onClick={() => history.push('/case/board')}
            >
              Case 페이지로 돌아가기
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Complete;
